export const numberFormatter = new Intl.NumberFormat("de-DE",{maximumFractionDigits: 2})